export default "__VITE_ASSET__CR3xt7I5__"